/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHeartS = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M15.994 3.006a5.7 5.7 0 0 0-3.795 1.707L12 4.916l-.199-.202a5.676 5.676 0 0 0-8.128 0c-2.231 2.275-2.231 5.953 0 8.228L12 21.428l8.326-8.486A5.873 5.873 0 0 0 22 8.828a5.873 5.873 0 0 0-1.675-4.115A5.693 5.693 0 0 0 16.262 3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgHeartS as HeartS };
